import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import {
  UserServiceCreateResponseJson,
  UserServiceListRequestJson,
} from '@vmspdb/definitions';

export const listUsers = createAction(
  '[User/API] List Users',
  props<{ params: UserServiceListRequestJson }>(),
);

export const listUsersFailure = createAction(
  '[User/API] List Users Failure',
  props<{ error: any }>(),
);

export const loadUsers = createAction(
  '[User/API] Load Users',
  props<{ users: UserServiceCreateResponseJson[] }>(),
);

export const addUser = createAction(
  '[User/API] Add User',
  props<{ user: UserServiceCreateResponseJson }>(),
);

export const upsertUser = createAction(
  '[User/API] Upsert User',
  props<{ user: UserServiceCreateResponseJson }>(),
);

export const addUsers = createAction(
  '[User/API] Add Users',
  props<{ users: UserServiceCreateResponseJson[] }>(),
);

export const upsertUsers = createAction(
  '[User/API] Upsert Users',
  props<{ users: UserServiceCreateResponseJson[] }>(),
);

export const updateUser = createAction(
  '[User/API] Update User',
  props<{ user: Update<UserServiceCreateResponseJson> }>(),
);

export const updateUsers = createAction(
  '[User/API] Update Users',
  props<{ users: Update<UserServiceCreateResponseJson>[] }>(),
);

export const deleteUser = createAction(
  '[User/API] Delete User',
  props<{ id: string }>(),
);

export const deleteUsers = createAction(
  '[User/API] Delete Users',
  props<{ ids: string[] }>(),
);

export const clearUsers = createAction('[User/API] Clear Users');
